import { createFileRoute } from "@tanstack/react-router";

import { PublisherShell } from "@/features/publisher";

export const Route = createFileRoute("/publisher")({
  component: PublisherShell,
});
